import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, useTheme, Box, Typography } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { retrieveContentfulImage } from '../../common/image.js';
import CenterContainer from '../../theme/CenterContainer.js';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      width: "100%",
      minHeight: theme.spacing(54.25)
    },
    item: _defineProperty({
      width: "50%"
    }, theme.breakpoints.down("sm"), {
      width: "100%"
    }),
    image: {
      maxHeight: theme.spacing(33),
      alignSelf: "center"
    },
    title: {
      background: "linear-gradient(bottom, ".concat(theme.palette.primary[100], " 60%, transparent 40%)"),
      display: "inline"
    },
    cta: {
      marginTop: theme.spacing(5)
    },
    ctaLabel: {
      color: theme.palette.text.white
    },
    dashedBox: {
      background: "#F7E8BF",
      border: "2px dashed ".concat(theme.palette.secondary[300]),
      maxWidth: theme.spacing(40.25)
    }
  };
});
var TitleHighlightTextCTA = function TitleHighlightTextCTA(_ref) {
  var _BUTTON_TYPES$cta$typ, _BUTTON_TYPES$cta$typ2;
  var bgColor = _ref.bgColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    text = _ref.text,
    description = _ref.description,
    cta = _ref.cta;
  var classes = useStyles();
  var theme = useTheme();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.wrapper,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(CenterContainer, {
    maxWidth: theme.breakpoints.width("lg")
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    px: isExtraSmallScreen() ? 0 : 3,
    pt: isExtraSmallScreen() ? 3.75 : 6,
    pb: isExtraSmallScreen() ? 3.75 : 6
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(Box, {
    mt: 4,
    className: classes.item
  }, title && /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    className: classes.title
  }, title)), subtitle && /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4"
  }, subtitle)), text && /*#__PURE__*/React__default.createElement(Box, {
    className: classes.dashedBox,
    mt: 2.125,
    pt: 2.375,
    pb: 1.75
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    align: "center"
  }, text)), /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    component: "div",
    align: "justify"
  }, description && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, description && /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
    markdownString: description
  })))), cta && /*#__PURE__*/React__default.createElement(CustomButton, {
    className: classes.cta
    // variant="contained"
    ,
    disableElevation: true,
    variant: (_BUTTON_TYPES$cta$typ = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ === void 0 ? void 0 : _BUTTON_TYPES$cta$typ.variant,
    color: (_BUTTON_TYPES$cta$typ2 = BUTTON_TYPES[cta === null || cta === void 0 ? void 0 : cta.type]) === null || _BUTTON_TYPES$cta$typ2 === void 0 ? void 0 : _BUTTON_TYPES$cta$typ2.color,
    href: cta === null || cta === void 0 ? void 0 : cta.url
  }, cta === null || cta === void 0 ? void 0 : cta.label)), !isSmallScreen() && !isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(Box, {
    className: classes.item,
    display: "flex",
    flexDirection: "column"
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, {
      width: 522,
      height: 344
    }),
    className: classes.image,
    alt: imageTitle || ""
  }))))));
};
TitleHighlightTextCTA.propTypes = {
  bgColor: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  text: PropTypes__default.string,
  description: PropTypes__default.string,
  cta: PropTypes__default.object
};

export { TitleHighlightTextCTA as default };
//# sourceMappingURL=TitleHighlightTextCta.js.map
